<template>
    <div class="auth-error-shell">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.auth-error-shell {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
}
</style>
